import _ from 'lodash';

import {
  GS_GET_VARIETALS_SUCCESS,

  GS_GET_VARIETALS_DETAILS_REQUEST,
  GS_GET_VARIETALS_DETAILS_SUCCESS,
  GS_GET_VARIETALS_DETAILS_FAILURE,

  GS_TOGGLE_VARIETALS_DETAILS_MODAL,
  GS_TOGGLE_VARIETALS_ADDNEW_MODAL,

  GS_SAVE_VARIETALS_DETAILS_SUCCESS,
  GS_SAVE_VARIETALS_DETAILS_FAILURE,

  GS_GET_NEXTERNAL_VARIETALS_SUCCESS,
  GS_GET_NEXTERNAL_VARIETALS_FAILURE,

  GS_ADD_NEW_VARIETAL_SUCCESS,
  GS_ADD_NEW_VARIETAL_FAILURE,

  GS_SEARCH_LIST,

  GS_DELETE_VARIETAL_SUCCESS,
  GS_DELETE_VARIETAL_FAILURE,

  GS_VARIETALS_GROUP_BY
} from './actions';

import createReducer from 'state/createReducer';

const initialState = {
  varietals: [],
  countries: [],

  details: {},
  nexternalVarietals: [],
  showDetailsModal: false,

  errorMessage: '',

  showAddNewModal: false,
  groupById: ''
}

const handlers = {
  [GS_GET_VARIETALS_SUCCESS](state, payload) {
    return {
      ...state,
      varietals: _.get(payload, 'varietals', []),
      countries: _.get(payload, 'countries', [])
    }
  },

  [GS_GET_NEXTERNAL_VARIETALS_SUCCESS](state, payload) {

    let nexternalVarietals = [];
    payload.forEach((v) => {
      nexternalVarietals.push({
        label: v.name,
        value: v.id
      })
    });

    
    return {
      ...state,
      nexternalVarietals: nexternalVarietals
    }
  },

  [GS_GET_VARIETALS_DETAILS_SUCCESS](state, payload) {
    

    return {
      ...state,
      showDetailsModal: true,
      details: payload.details
    }
  },

  [GS_TOGGLE_VARIETALS_DETAILS_MODAL](state, payload) {

    if (payload.show === false) {
      return {
        ...state,
        showDetailsModal: payload.show,
        details: {}
      }
    } else {
      return {
        ...state,
        showDetailsModal: payload.show
      }
    }
  },

  [GS_TOGGLE_VARIETALS_ADDNEW_MODAL](state, payload) {

    return {
      ...state,
      showAddNewModal: payload.show
    }
  },

  [GS_SAVE_VARIETALS_DETAILS_SUCCESS](state) {
    return {
      ...state,
    }
  },

  [GS_SAVE_VARIETALS_DETAILS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  },

  [GS_ADD_NEW_VARIETAL_SUCCESS](state) {
    return {
      ...state,
    }
  },

  [GS_ADD_NEW_VARIETAL_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  },

  [GS_SEARCH_LIST](state, payload) {

    const newList = _.cloneDeep(state.varietals);
    const groupById = _.cloneDeep(state.groupById);

    const lq = payload.toLowerCase();

    if (groupById !== "") {
      for (let l of newList.data) {
        for (let o of l.Varietals) {
          const name = o.name.toLowerCase();

          o.filtered = !name.includes(lq);
        }
      }
    } else {
      newList.forEach((elem) => {
        const name = elem.name.toLowerCase();

        elem.filtered = !name.includes(lq);
      });
    }

    return {
      ...state,
      varietals: newList
    }
  },

  [GS_DELETE_VARIETAL_SUCCESS](state, payload) {
    return {
      ...state
    }

  },

  [GS_DELETE_VARIETAL_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    }
  },

  [GS_VARIETALS_GROUP_BY](state, payload) {
    return {
      ...state,
      groupById: payload.groupBy,
      varietals: []
    }
  },
};

export default (state = initialState, action) => createReducer(state, action, handlers);